/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useUserPreferences } from "../../../hooks";
import { getFilledArrayOrDefault } from "../../../utils";
import SingleSelect from "../../Forms/SingleSelect";
import { useManagedOptionsHook } from "../../Forms/useManagedOptionsHook";

export default function AssignedTeamFilter() {
    const [userPreferences, updatePreferences] = useUserPreferences();

    const options = useManagedOptionsHook({ object: {}, name: "teams" });

    return (
        <div css={css`
            width: 20rem;
            z-index: 1000;
            @media (max-width: 992px) {
                width: 100%;
                min-width: 15rem;
            }
        `} className="mb-n3">

            <SingleSelect
                options={getFilledArrayOrDefault(options).map(({ value, label }) => ({ value, label }))}
                field="assigned_team"
                setValue={(_, value) => updatePreferences({ assigned_team: getFilledArrayOrDefault(value as string[]) })}
                post_value={userPreferences.assignedTeam}
                label={false}
                multi={true}
                isClearable={true}
                return_array={true}
                placeholder="Select assigned teams"
            />
        </div>
    );
}
